// extracted by mini-css-extract-plugin
export default {"modalOverlay":"style_modalOverlay__qyafG","modalContent":"style_modalContent__C4rK9","closeButton":"style_closeButton__+yW12"};